function getCustomOptions() {
    const selector = document.querySelector('.fake-option-selector');
    
    if (!selector) return;

    selector.addEventListener('click', (event) => {
        const isOpen = selector.getAttribute('open') === 'true';
        selector.setAttribute('open', isOpen ? 'false' : 'true');
    });

    const realOptions = document.querySelectorAll('.select .select__select[name="options[Talla]"] option');
    const fakeOptions = document.querySelectorAll('.option-selector__container .option-selector__options');
    const selectText = document.querySelector('.option-selector__initial');

    fakeOptions.forEach((option) => {
        option.addEventListener('click', (event) => {
            const selectedOption = event.currentTarget;
            console.log(selectedOption);
            const size = selectedOption.getAttribute('value');
            const match = [...realOptions].find(option => option.value === size);
            console.log(match);
            
            if (match) {
                match.selected = true;
                const realSelect = match.closest('select');
                const event = new Event('change', { bubbles: true });
                realSelect.dispatchEvent(event);
                selector.setAttribute('open', 'false');
                selectText.textContent = selectedOption.textContent;

                fakeOptions.forEach((option) => {
                    if (option === selectedOption) {
                        option.classList.add('option-selector__options--selected');
                    } else {
                        option.classList.remove('option-selector__options--selected');
                    }
                });
            } else {
                console.error(`No matching option found for value: ${size}`);
            }
        });
    });
}

document.addEventListener('DOMContentLoaded', getCustomOptions);